module.exports = __webpack_public_path__ + "static/media/am.cb256127.svg";